import gql from 'graphql-tag';

export const eventsQuery = gql`
  query eventsQuery {
    events {
      id
      weddingId
      attire
      requireRsvp
      notes
      name
      type
      date
      time
      endTime
      visible
      createdAt
      location {
        ...Locations
      }
      questions {
        ...Questions
      }
      subEvents {
        id
        name
        time
        endTime
        type
        attire
        notes
        visible
        location {
          ...Locations
        }
      }
    }
  }

  fragment Locations on GDS_Location {
    name
    street1
    city
    state
    zip
    country
  }
  fragment Questions on GDS_Question {
    id
    text
    type
    answerDestination
    answerType
    options {
      id
      text
      description
    }
    isRequired
  }
`;
